import { useState } from 'react';

import {
  PlayInstantAdcampaignMutationInput,
  useMediaAdCampaignInstantLaunchMutation,
} from '@shared/api/graphql/generated';
import { BaseMutationResultType, FetchPolicyKeys } from '@shared/api/graphql/types';

export type UseAdCampaignInstantLaunchResultType = BaseMutationResultType;

export type UseAdCampaignInstantLaunchType = {
  request: (input: PlayInstantAdcampaignMutationInput) => Promise<boolean>;
  result: UseAdCampaignInstantLaunchResultType;
  abortRequest: () => void;
};

const useAdCampaignInstantLaunch = (): UseAdCampaignInstantLaunchType => {
  const [aborter, setAborter] = useState(new AbortController());

  const [launchMutation, launchMutationResult] = useMediaAdCampaignInstantLaunchMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
    context: {
      fetchOptions: {
        signal: aborter.signal,
      },
    },
    notifyOnNetworkStatusChange: true,
  });

  const request = async (input: PlayInstantAdcampaignMutationInput) => {
    const result = await launchMutation({
      variables: {
        input,
      },
    });

    return !!result.data?.playInstantAdcampaign?.ok;
  };

  const abortRequest = () => {
    aborter.abort();
    setAborter(new AbortController());
  };

  const result: UseAdCampaignInstantLaunchResultType = {
    error: launchMutationResult.error,
    loading: launchMutationResult.loading,
    called: launchMutationResult.called,
  };

  return { request, result, abortRequest };
};

export default useAdCampaignInstantLaunch;
